import React, { useState, useEffect, useRef } from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { Space } from "@masterteam/mt-design-react";

import useIsAr from "../../../Hooks/useIsAr";

function SubItemsMenu({ item, isActive, setIndex, pathname, index }) {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef();
  const [isAr] = useIsAr();

  const handleClickOutside = (event) => {
    if (wrapperRef?.current && !wrapperRef?.current?.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div ref={wrapperRef}>
      <Space
        align="center"
        className={`menu-item ${isActive && "active"} cursor`}
        onClick={() => {
          setIsOpen(!isOpen);
        }}
      >
        {item?.icon ? <div className="menu-item_icon">{item?.icon}</div> : null}
        <FormattedMessage id={item.name} defaultMessage={item.name} />
      </Space>

      <div className={`weight-dropdown-content ${isOpen && "display-block"}`}>
        {item?.subItems?.map((subItem, subItemIndex) => (
          <Link
            key={subItemIndex}
            to={subItem?.path}
            onClick={() => {
              setIsOpen(false);
              setIndex(subItemIndex);
            }}
          >
            <div
              className={`admin-layout__ddl-item ${
                pathname === subItem?.path && "admin-layout__ddl-item-active"
              }`}
            >
              {subItem?.icon && (
                <span className="admin-layout__ddl-item__icon">
                  {subItem?.icon}
                </span>
              )}

              {subItem.name ? (
                <FormattedMessage
                  id={subItem.name}
                  defaultMessage={subItem.name}
                />
              ) : isAr ? (
                <div>{subItem.arabicName}</div>
              ) : (
                <div>{subItem.englishName}</div>
              )}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default SubItemsMenu;
